import { c as _c } from "react/compiler-runtime";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { useRouter } from "next/router";
import { GetBalanceMutationKey, GetBalanceResponseTypes } from "./types";
export const getBalanceApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/users/balance`;
export const useGetBalance = () => {
  const $ = _c(11);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [GetBalanceMutationKey];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== router) {
    t1 = {
      queryKey: t0,
      queryFn: () => fetcher({
        url: getBalanceApiURL
      }, router).then(_temp),
      retry: false
    };
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: data_0,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch
  } = useFetcher(t1);
  let t2;
  if ($[3] !== data_0) {
    t2 = data_0 || {
      balance: 0,
      creditLimit: 0,
      ledgerBalance: 0
    };
    $[3] = data_0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isError || error;
  let t4;
  if ($[5] !== isLoading || $[6] !== isSuccess || $[7] !== refetch || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      isLoadingGetBalance: isLoading,
      balance: t2,
      isBalanceError: t3,
      isSuccess,
      refetch
    };
    $[5] = isLoading;
    $[6] = isSuccess;
    $[7] = refetch;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(t0) {
  const {
    data
  } = t0;
  return data as GetBalanceResponseTypes;
}